export default __webpack_public_path__ + "static/media/3x1.1888b7b4.svg";